import _extends from "@babel/runtime/helpers/esm/extends";
export const activateClickedItem = (listData, index, subIndex) => {
  return listData === null || listData === void 0 ? void 0 : listData.map((m, i) => {
    if (i === index) {
      return _extends(_extends({}, m), {
        items: m.items.map((n, k) => {
          if (k === subIndex) {
            return _extends(_extends({}, n), {
              active: true
            });
          } else {
            return _extends(_extends({}, n), {
              active: false
            });
          }
        })
      });
    }
    if (index >= 0) {
      return _extends(_extends({}, m), {
        items: m.items.map(n => {
          return _extends(_extends({}, n), {
            active: false
          });
        })
      });
    }
    return m;
  });
};